<template>
    <register-admin ref="registerAdmin" v-bind:is-me="false" v-bind:is-sxhmatismos="true" v-bind:title="'Δημιουργία Διαχειριστή Σχηματισμού'" />
</template>

<script>
import RegisterAdmin from "./RegisterAdmin";
import {HTTP} from "../main";

export default {
    name: "RegisterSxhmatismos",
    components: {
        RegisterAdmin
    },
    created() {
        if (!this.$store.getters.isAdmin) this.$router.push('/');
        this.$store.dispatch("loading")
        HTTP.get( "/admin/find-all-sxhmatismoi")
            .then(response => {
                    let resp = response.data;
                    this.$refs.registerAdmin.me_items = resp.responseData.map((x) => {
                        return {value: x, text: x.monaLek}
                    })
                }
            ).finally(() => this.$store.dispatch("stop_loading"))
    },
}
</script>

<style scoped>

</style>